import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { ESubscriptionModalAction } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';

export enum BillingBuyTemplates {
    CLOUD_B2C_MOBILE = 'CLOUD_B2C_MOBILE',
    CLOUD_B2C_REG_MOBILE = 'CLOUD_B2C_REG_MOBILE',
    CLOUD_B2C = 'CLOUD_B2C',
    CLOUD_B2C_REG = 'CLOUD_B2C_REG',
    CHECKOUT_VKPAY = 'CHECKOUT_VKPAY',
    CHECKOUT_VKPAY_NOOFFER = 'CHECKOUT_VKPAY_NOOFFER',
}

export enum BillingBuyViewTemplates {
    checkout = 'checkout',
}

export interface RenewApiParams {
    sub_id: string | number;
    skin?: BillingBuyTemplates;
    view?: BillingBuyViewTemplates;
    hide_pay_methods_menu?: boolean;
    pay_method?: string;
}

export enum BuyNotifications {
    renewFailure = 'SUBSCRIPTION_RENEW_FAILURE',
    cancelAutoRenewSuccess = 'SUBSCRIPTIONS_CANCEL_AUTORENEW_SUCCESS',
    cancelAutoRenewFailure = 'SUBSCRIPTIONS_CANCEL_AUTORENEW_FAILURE',
    autoRenewFailure = 'SUBSCRIPTIONS_AUTORENEW_FAILURE',
    autoRenewSuccess = 'SUBSCRIPTIONS_AUTORENEW_SUCCESS',
    cancelAutoRenewAddTrialSuccess = 'SUBSCRIPTIONS_CANCEL_AUTORENEW_ADD_TRIAL_SUCCESS',
    cancelAutoRenewAddTrialFailure = 'SUBSCRIPTIONS_CANCEL_AUTORENEW_ADD_TRIAL_FAILURE',
    pauseSubscriptionFailure = 'PAUSE_SUBSCRIPTION_FAILURE',
    setDiscountInOutflowSuccess = 'SET_DISCOUNT_IN_OUTFLOW_SUCCESS',
    setDiscountInOutflowFailure = 'SET_DISCOUNT_IN_OUTFLOW_FAILURE',
}

export interface IOpenCancelMailSubsDialogAction {
    subscription: BillingDataSubscriptionInfo;
}

export interface IAddAutoRenewAction {
    subscription: BillingDataSubscriptionInfo;
}

export interface ICancelAutorenewSubscription {
    subscriptionId: string | number;
    captchaId?: number;
    captchaValue?: string;
    sendAnalytics?: (action: ESubscriptionModalAction) => void;
    period?: string;
    isRebrandingQuotaLanding?: boolean;
    onSuccess?: () => void;
    showSurvey?: boolean;
}

export interface IRenewSubscription {
    id: string;
}

export interface PauseSubscription {
    subscriptionId: string;
    period: string;
}

export interface CheckPauseSubscription {
    subscriptionId: string | number;
}
export interface CheckDiscountInOutflow {
    subscriptionId: string | number;
}

export interface SetDiscountInOutflow {
    subscriptionId: string | number;
}

export interface SetCanSetDiscountInOutflow {
    canSetDiscountInOutflow: boolean;
    discountInOutflow?: number;
    discountInOutflowPercent?: number;
}

// tempexp_18907-start

export interface SetDiscountInOutflowSave {
    status: boolean;
    period: number;
}

// tempexp_18907-end
